import "../css/style.scss"
//import { Tooltip, Toast, Popover} from 'bootstrap';
import * as bootstrap from 'bootstrap'


// Our modules / classes

import Authentication from "./modules/Authentication"
import HeroSlider from "./modules/HeroSlider"
import UISlider from "./modules/UISlider"
import Video from "./modules/Video"
import FancyBox from "./modules/FancyBox"
import AddWish from "./modules/AddWishList"
import Search from "./modules/Search"
//import MyNotes from "./modules/MyNotes"
//import Like from "./modules/Like"

// Instantiate a new object using our modules/classes

const mobileMenu = new Authentication()
const heroSlider = new HeroSlider()
const video = new Video()
const fancyBox = new FancyBox()
const uiSlider = new UISlider()
const search = new Search()
const wish= new AddWish()
